import entryFactory from 'bpmn-js-properties-panel/lib/factory/EntryFactory'

import cmdHelper from 'bpmn-js-properties-panel/lib/helper/CmdHelper'

export default function(element, bpmnFactory, options, translate) {
  let inputVariableName = entryFactory.textField({
    id: 'inputVariableName',
    label: 'Input Variable Name',
    modelProperty: 'inputVariableName',

    set: function(element, values, node) {
      let bo = element.businessObject
      let prop = {}
      prop['inputVariableName'] = values.inputVariableName
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      var inputVariableNameVar = bo.get('inputVariableName')
      return {
        inputVariableName: inputVariableNameVar,
        label: 'Please provide the Input Variable Name'
      }
    },
    validate: function(element, values, node) {
      return !values.inputVariableName
        ? { inputVariableName: 'Must provide a value' }
        : {}
    }
  })

  let jsonPathExpression = entryFactory.textBox({
    id: 'jsonPathExpression',
    label: 'JsonPath Expression',
    modelProperty: 'jsonPathExpression',

    set: function(element, values, node) {
      let bo = element.businessObject
      let prop = {}
      prop['jsonPathExpression'] = values.jsonPathExpression
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      var jsonPathExpressionVar = bo.get('jsonPathExpression')
      return {
        jsonPathExpression: jsonPathExpressionVar,
        label: 'Please provide the JsonPath Expression'
      }
    },
    validate: function(element, values, node) {
      return !values.jsonPathExpression
        ? { jsonPathExpression: 'Must provide a value' }
        : {}
    }
  })

  let jsonPathHelpText = entryFactory.link({
    id: 'jsonPathHelpText',
    label: 'Please refer this for samples on JsonPath expressions',
    showLink: function() {
      return true
    },
    handleClick: function() {
      window.open(
        'https://github.com/eugenp/tutorials/tree/master/json-path',
        '_blank'
      )
    }
  })

  let outputVariableName = entryFactory.textField({
    id: 'outputVariableName',
    label: 'Output Variable Name',
    modelProperty: 'outputVariableName',

    set: function(element, values, node) {
      let bo = element.businessObject
      let prop = {}
      prop['outputVariableName'] = values.outputVariableName
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      var outputVariableNameVar = bo.get('outputVariableName')
      return {
        outputVariableName: outputVariableNameVar,
        label: 'Please provide the Output Variable Name'
      }
    },
    validate: function(element, values, node) {
      return !values.outputVariableName
        ? { outputVariableName: 'Must provide a value' }
        : {}
    }
  })

  return [
    inputVariableName,
    jsonPathExpression,
    jsonPathHelpText,
    outputVariableName
  ]
}
